import React from 'react';
import '../styles/ButtonContainer.css';

class ButtonContainer extends React.Component {
    render() {
        return (
            <div className="container">
                {this.props.children}
            </div>
        );
    }
}

export default ButtonContainer